import { ValidationResult } from "@components/WizardCst/types";

export const validateEditorial = (): ValidationResult => ({
  valid: true,
  errors: {},
});

export const skipEditorialForNonStandalone = (data: {
  is_standalone?: boolean;
}): boolean => data.is_standalone === false;
